import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable, of, switchMap, throwError } from 'rxjs';
import { BaseRestApiService } from 'src/app/service/baseRestApiService.service';
import { UrlProviderService, EndPoints } from 'src/app/service/urlprovider.service';

@Injectable({
    providedIn: 'root'
})
export class StudentDeduplicationService extends BaseRestApiService {
    constructor(http: HttpClient, urlProvider: UrlProviderService) {
        super(http, urlProvider);
    }

    getDuplicatesCount(): Observable<any> {
        return this.get<any>(EndPoints.studentDeduplication_GetDuplicatesCount);
    }

    getUnresolvedDuplicatesByRegion(regionCode: string): Observable<any> {
        return this.get<any>(EndPoints.studentDeduplication_GetUnresolvedDuplicatesByRegion, '', regionCode);
    }

    getResolvedDuplicatesByRegion(regionCode: string, dateStart?: Date, dateEnd?: Date, showSystemDuplicateResolutions?: boolean): Observable<any> {
        return this.post<any>(EndPoints.studentDeduplication_GetResolvedDuplicatesByRegion, false, null, {
            regionCode: regionCode,
            dateStart: dateStart,
            dateEnd: dateEnd,
            showSystemDuplicateResolutions: showSystemDuplicateResolutions
        }).pipe(
            switchMap((duplicateResolutions) => {
                return of(JSON.parse(JSON.stringify(duplicateResolutions)));
            })
        );
    }

    indexDuplicateResolutionStudentStatuses(): Observable<any> {
        return this.get<any>(EndPoints.studentDeduplication_IndexDuplicateResolutionStudentStatuses);
    }

    indexDuplicateResolutionTypes(): Observable<any> {
        return this.get<any>(EndPoints.studentDeduplication_IndexDuplicateResolutionTypes);
    }

    showDuplicateResolution(id: number): Observable<any> {
        return this.get<any>(EndPoints.studentDeduplication_ShowDuplicateResolution, '', id);
    }

    updateDuplicateResolutionType(duplicateResolutionID: number, duplicateResolutionStudentRegion: any): Observable<any> {
        return this.post<any>(EndPoints.studentDeduplication_UpdateDuplicateResolutionType, false, null, {
            duplicateResolutionID: duplicateResolutionID,
            duplicateResolutionStudentRegion: duplicateResolutionStudentRegion
        }).pipe(
            switchMap((msg) => {
                return of(msg);
            }),
            catchError((err) => {
                return throwError(() => new Error(err));
            })
        );
    }

    resolveDuplicateResolutionMerged(duplicateResolution: any): Observable<any> {
        return this.post<any>(EndPoints.studentDeduplication_ResolveDuplicateResolutionMerged, false, null, {
            duplicateResolution: duplicateResolution
        }).pipe(
            switchMap((msg) => {
                return of(msg);
            }),
            catchError((err) => {
                return throwError(() => new Error(err));
            })
        );
    }

    resolveDuplicateResolutionDifferent(duplicateResolution: any): Observable<any> {
        return this.post<any>(EndPoints.studentDeduplication_ResolveDuplicateResolutionDifferent, false, null, {
            duplicateResolution: duplicateResolution
        }).pipe(
            switchMap((msg) => {
                return of(msg);
            }),
            catchError((err) => {
                return throwError(() => new Error(err));
            })
        );
    }

    revertDuplicateResolutionMerged(duplicateResolution: any): Observable<any> {
        return this.post<any>(EndPoints.studentDeduplication_RevertDuplicateResolutionMerged, false, null, {
            duplicateResolution: duplicateResolution
        }).pipe(
            switchMap((msg) => {
                return of(msg);
            }),
            catchError((err) => {
                return throwError(() => new Error(err));
            })
        );
    }

    revertDuplicateResolutionDifferent(duplicateResolution: any): Observable<any> {
        return this.post<any>(EndPoints.studentDeduplication_RevertDuplicateResolutionDifferent, false, null, {
            duplicateResolution: duplicateResolution
        }).pipe(
            switchMap((msg) => {
                return of(msg);
            }),
            catchError((err) => {
                return throwError(() => new Error(err));
            })
        );
    }

    addDuplicateResolution(student1ID: number, student2ID: number): Observable<any> {
        return this.post<any>(EndPoints.studentDeduplication_AddDuplicateResolution, false, null, {
            student1ID: student1ID,
            student2ID: student2ID
        }).pipe(
            switchMap((msg) => {
                return of(msg);
            }),
            catchError((err) => {
                return throwError(() => new Error(err));
            })
        );
    }

    getStudentMergedTree(studentId: number): Observable<any> {
        return this.post<any>(EndPoints.studentDeduplication_GetStudentMergedTree, false, null, {
            studentId: studentId
        }).pipe(
            switchMap((studentMergedTree) => {
                return of(studentMergedTree);
            })
        );
    }

    showResolvedDuplicatesByStudentId(studentId: number): Observable<any> {
        return this.post<any>(EndPoints.studentDeduplication_ShowResolvedDuplicatesByStudentId, false, null, {
            studentId: studentId
        }).pipe(
            switchMap((duplicateResolutions) => {
                return of(JSON.parse(JSON.stringify(duplicateResolutions)));
            })
        );
    }
}
